import { inject } from '@angular/core';
import { Router, type CanActivateFn } from '@angular/router';
import { AuthService } from '../services/auth.service';

export const permisosGuard: CanActivateFn = (route) => {
  const authService = inject(AuthService);
  const router = inject(Router);

  const modulo = route.data['modulo'] as string | undefined;
  const permiso = route.data['permiso'] as string | undefined;
  const allowedRoles = route.data['allowedRoles'] as number[] | undefined;

  if (!modulo || !permiso) {
    router.navigateByUrl('/');
    return false;
  }


  if (authService.hasModulePermission(modulo, permiso)) {
    return true;
  }


  if (allowedRoles && authService.hasRole(allowedRoles)) {
    return true;
  }

  router.navigateByUrl('/');
  return false;
};

